// export const environment = {
//   production: false,
//   buildNo:202610131901,
//   version:'Uat 2.0.1',
//   baseUrl: 'https://uat.csmsv2.mojosoft.co.in/ws',
//   userId: 'epsv2',
//   password: 'epsv2',
//   appKey:"9de94aeab49231fc7c8f5e3e07d368fa"
// };


export const environment = {
  production: false,
  buildNo:202610131901,
  version: 'Uat 2.0.1',
  baseUrl: 'https://ws.uat.epsv2.mojosoft.co.in/',
  assetsUrl: 'https://ws.uat.epsv2.mojosoft.co.in/resources',
  assetsPosAdsPath: '/ads/pos',
  userId: 'epsv2',
  password: 'epsProdPass123#@!',
  appKey: "3b83c3b6b69ae6907b892320bc3d8087"
};
